import React from "react";
import { FiX } from "react-icons/fi";
import chatbotIcon from "../../assets/images/chatbot.png";
import useChatStore from "../../store/useChatStore";
import { AiOutlineFullscreenExit } from "react-icons/ai";
import { AiOutlineFullscreen } from "react-icons/ai";
import { IoIosArrowBack } from "react-icons/io";
import useSocketStore from "../../store/useSocketStore";

const ChatHeader = ({ closeChat, handelsqwitch, isHomePage, sqwitch }) => {
  const {
    socketInstance,
    disconnectSocket,
    setUserUUID,
    setCustomerUUID,
    setChat,
    endConversation,
    conversationUUID,
    setConversationUUID,
  } = useSocketStore();
  const {
    currentScreen,
    setCurrentScreen,
    isFetched,
    setIsFetched,
    setInputValue,
    setTicketRaisedInfo,
    chatbotTheme,
  } = useChatStore();
  const handleBack = () => {
    if (currentScreen === "login") {
      setCurrentScreen("home");
    } else if (currentScreen === "otp") {
      setCurrentScreen("login");
    } else if (currentScreen === "track-order") {
      setCurrentScreen("home");
    } else if (currentScreen === "order-details") {
      setCurrentScreen("track-order");
    } else if (currentScreen === "chat") {
      setIsFetched(true);
      setCurrentScreen("orderList");
    } else if (currentScreen === "supportInfo") {
      setCurrentScreen("home");
    } else if (currentScreen === "orderList" && isFetched) {
      setIsFetched(false); // Reset isFetched
    } else if (currentScreen === "orderList") {
      setCurrentScreen("home");
      setInputValue("");
    } else if (currentScreen === "ticketrised") {
      setTicketRaisedInfo([]);
      setCurrentScreen("ticketfetched");
    } else if (
      currentScreen === "ticketfetched" ||
      currentScreen === "mail-us"
    ) {
      setCurrentScreen("home");
    } else if (currentScreen === "one-to-one") {
      setCurrentScreen("home");
      setChat([]);
      setCustomerUUID("");
      setUserUUID("");
      endConversation(conversationUUID, socketInstance);
      disconnectSocket();
      setConversationUUID("");
    }
  };
  return (
    <div
      className="chat-header"
      style={{ backgroundColor: isHomePage ? "transparent" : chatbotTheme }}
    >
      {currentScreen !== "home" ? (
        <div className="chat-header-logo">
          <button
            className="back-button"
            onClick={handleBack}
            aria-label="Go back"
          >
            {/* <FiArrowLeft /> */}
            <IoIosArrowBack />
          </button>
          <div>
            <img src={chatbotIcon} alt="Chatbot" className="chatbot-icon" />
          </div>
          <div>
            <p id="matrix">Lopaa</p>
            <p id="aiagent">Ai Agent</p>
          </div>
        </div>
      ) : null}

      {currentScreen === "home" ? (
        <div className="chat-header-content">
          <img src={chatbotIcon} alt="Chatbot" className="chatbot-icon" />
        </div>
      ) : null}

      {currentScreen === "supportInfo" ? (
        <>
          {sqwitch === 500 ? (
            <button
              className="close-chat-btn"
              onClick={handelsqwitch}
              aria-label="Close Chat"
            >
              <AiOutlineFullscreenExit />
            </button>
          ) : (
            <button
              className="close-chat-btn"
              onClick={handelsqwitch}
              aria-label="Close Chat"
            >
              <AiOutlineFullscreen />
            </button>
          )}
        </>
      ) : (
        <>
          <button
            className="close-chat-btn"
            onClick={closeChat}
            aria-label="Close Chat"
          >
            <FiX />
          </button>
        </>
      )}
    </div>
  );
};

export default ChatHeader;
